module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-in-down-left-7a466af4.svg";